import { render, staticRenderFns } from "./VillageTable.vue?vue&type=template&id=2b710122&scoped=true&"
import script from "./VillageTable.vue?vue&type=script&lang=js&"
export * from "./VillageTable.vue?vue&type=script&lang=js&"
import style0 from "./VillageTable.vue?vue&type=style&index=0&id=2b710122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b710122",
  null
  
)

export default component.exports